<template>
<div class="edit">
    <div>
        基础信息配置
    </div>
    <el-form class="detail" :model="detail" label-width="180px" :rules="rule" ref="form1" >
        <el-form-item :label="item.label" :prop="item.prop" v-for="item in infoConfig" v-if="!item.hide" style="margin-top: 20px">
            <el-input v-if="item.prop === 'id'" disabled :type="item.type" :rows="5" v-model="detail[item.prop]"></el-input>

            <!-- 媒体名称 -->
            <el-select v-model="detail[item.prop]" filterable :filter-method="filterMedia" v-else-if="item.prop === 'mediaId'" @change="onMediaChange">
                <el-option v-for="option in filteredMediaList" :key="option.id" :value="option.id" :label="option.name"/>
            </el-select>

            <span v-if="item.tip">{{item.tip}}</span>
        </el-form-item>
    </el-form>
    <div>
        广告样式配置
    </div>

    <el-form class="detail" :model="detail" label-width="180px" :rules="rule" ref="form2" >
        <el-form-item :label="item.label" :prop="item.prop" v-for="item in styleConfig" v-if="!item.hide" style="margin-top: 20px">
            <!--广告资源类型-->
            <el-radio-group v-model="detail[item.prop]" v-if="item.prop === 'adResourceType' && detail[item.prop] === 3"  disabled @change="onAdResourceTypeChange">
                <el-radio v-for="it in detail.adResourceTypeList"  :label="it.id" :key="it.id">{{it.name}}</el-radio>
            </el-radio-group>
            <el-radio-group v-model="detail[item.prop]" v-else-if="item.prop === 'adResourceType' && detail[item.prop] !== 3" @change="onAdResourceTypeChange">
                <el-radio v-for="it in detail.adResourceTypeList"  :label="it.id" :key="it.id">{{it.name}}</el-radio>
            </el-radio-group>
            <!--渲染方式-->
            <el-radio-group v-model="detail[item.prop]" v-else-if="item.prop === 'renderingType'">
                <el-radio v-for="it in renderingTypeList"  :label="it.id" :key="it.id">{{it.name}}</el-radio>
            </el-radio-group>
            <!--素材类型-->
            <el-radio-group v-model="detail[item.prop]" v-else-if="item.prop === 'materialType'" >
                <el-radio v-for="it in computedMaterialTypeList"  :label="it.id" :key="it.id">{{it.name}}</el-radio>
            </el-radio-group>
            <!--屏幕方向-->
            <el-radio-group v-model="detail[item.prop]" v-else-if="item.prop === 'verticalSupport'">
                <el-radio v-for="it in computedVerticalSupportList"  :label="it.id" :key="it.id">{{it.name}}</el-radio>
            </el-radio-group>
        </el-form-item>
    </el-form>
    <div>
        价格信息配置
    </div>
    <el-form class="detail" :model="detail" label-width="180px" :rules="rule" ref="form3" >
        <el-form-item :label="item.label" :prop="item.prop" v-for="item in priceConfig" v-if="!item.hide" style="margin-top: 20px">
            <el-radio-group v-model="detail[item.prop]" v-if="item.prop === 'showPrice'" @change="onShowPriceChange">
                <el-radio v-for="it in showPriceList"  :label="it.id" :key="it.id">{{it.name}}</el-radio>
            </el-radio-group>
            <el-radio-group v-model="detail[item.prop]" v-if="item.prop === 'expectPrice'" @change="onExpectPriceChange">
                <el-radio v-for="it in expectPriceList"  :label="it.id" :key="it.id">{{it.name}}</el-radio>
            </el-radio-group>
            <el-input v-else-if="item.prop === 'sharePrice'" :type="item.type" v-model="detail['sharePrice']"></el-input>
            <span v-if="item.tip">{{item.tip}}</span>
        </el-form-item>
    </el-form>
    <div>
        填写广告位名称
    </div>
    <el-form class="detail" :model="detail" label-width="180px" :rules="rule" ref="form4" >
        <el-form-item :label="item.label" :prop="item.prop" v-for="item in nameConfig" v-if="!item.hide" style="margin-top: 20px">
            <el-input if="item.prop === 'name'" :type="item.type" :rows="5" v-model="detail[item.prop]"></el-input>
            <span v-if="item.tip">{{item.tip}}</span>
        </el-form-item>
    </el-form>
    <el-button style="margin-left: 100px" type="primary" @click="save" >保存</el-button>

</div>
    
</template>

<script>
import BasePage from './BasePage.vue'
import {sspApi} from '@/api';
import _ from 'lodash'

export default {
    components: {
        BasePage
    },
    data: function () {
        return {
            showPriceList: [
                {name: "CPM底价", id: 2},
                {name: "竞价", id: 1},
            ],
            expectPriceList: [
                {name: "期望CPM底价", id: 1},
                {name: "不设置CPM底价", id: 2},
            ],
            verticalSupportList: [
                {name: "横版&竖版", id: 1},
                {name: "横版", id: 0},
                {name: "竖版", id: 2},
            ],
            materialTypeList: [
                {name: "图片&视频", id: 1},
                {name: "图片", id: 2},
                {name: "视频", id: 3}
            ],
            renderingTypeList: [
                {name: "自渲染", id: 1},
                {name: "模板渲染", id: 2},
            ],
            detail: {
                id: undefined,
                name: '',
                mediaId: undefined,
                adResourceType: 1,
                renderingType: 1,
                materialType: 3,
                verticalSupport: 0,
                showPrice: 2,
                expectPrice: 1,
                sharePrice: 0.01,
                adResourceTypeList:[],
                mediaList: []
            },
            filterMediaValue: "",
            showCpmFloor: 1,
            showExpectPrice: 1,
        }
    },
    created: function() {
        console.log("created")
        console.log(this.adzoneId)

        sspApi.getAdzoneConfig({
            params: {adzoneId: this.adzoneId}
        }).then((response) => {
            _.assign(this.detail, response)
            if (this.detail && this.detail.adzone) {
                _.assign(this.detail, this.detail.adzone)
            }
            if (this.detail.mediaId) {
                let media = _.find(this.filteredMediaList, ['id', this.detail.mediaId])
                if (media.accessType === "SDK") {
                    if (this.detail.adResourceType !== 1 && this.detail.adResourceType !== 2) {
                        this.renderingTypeList = [{name: "模版渲染", id: 2}]
                    }
                } else {
                    this.renderingTypeList = [{name: "自渲染", id: 1}]
                }
            }
        }).catch(this.$rejectAjaxError());

    },
    computed: {
        computedVerticalSupportList: function () {
          if (this.detail.adResourceType === 2) {
            return _.filter(this.verticalSupportList, (it) => {
              return it.id === 2
            })
          } else if (this.detail.adResourceType === 4){
            if (this.detail.mediaId) {
              let media = _.find(this.filteredMediaList, ['id', this.detail.mediaId])
              if (media.accessType === "SDK" && this.detail.renderingType === 2) {
                return _.filter(this.verticalSupportList, (it) => {
                  return it.id === 0
                })
              }
            }
          }
          return this.verticalSupportList;
        },
        computedMaterialTypeList: function () {
          if (this.detail.adResourceType == 5) {
            return _.filter(this.materialTypeList, (it) => {
              return it.id === 3
            })
          }
          return this.materialTypeList;
        },
        infoConfig: function () {
            return [
                {prop: 'id', label: '广告位ID', tip: '提交后系统自动生成，无需填写'},
                {prop: 'mediaId', label: '所属媒体'},
            ]
        },
        styleConfig: function () {
            return [
                {prop: 'adResourceType', label: '广告类型'},
                {prop: 'renderingType', label: '渲染方式'},
                {prop: 'materialType', label: '素材类型'},
                {prop: 'verticalSupport', label: '素材方向'},
            ]
        },
        priceConfig: function () {
            return [
                {prop: 'showPrice', label: '结算方式'},
                {prop: 'expectPrice', label: '', hide: !this.displayExpectPrice},
                {prop: 'sharePrice', label: 'CPM底价', tip:'单位元/千次曝光价格，支持两位小数设置', hide:!this.displayCpmFloor},
            ]
        },
        nameConfig: function () {
            return [
                {prop: 'name', label: '广告位名称', tip:'建议命名按照"联盟-应用名称-操作系统-素材类型-具体位置信息"'}
            ]
        },
        filteredMediaList: function () {
            if (this.detail.mediaList) {
                return _.filter(this.detail.mediaList, (it) => {
                    return (it.id + "").includes(this.filterMediaValue) || (it.name + "").includes(this.filterMediaValue)
                })
            }
            return []
        },
        displayCpmFloor: function () {
            return this.showCpmFloor === 1
        },
        displayExpectPrice: function () {
            return this.showExpectPrice === 1
        },
        adzoneId: function() {
            return this.$route.params.adzoneId
        },

    },
    watch: {
        'detail.showPrice': function(value) {
            if (value === 2) {
                this.showExpectPrice = 1
            } else {
                this.showExpectPrice = 2
            }
        },
        'detail.expectPrice': function(value) {
            if (value === 1) {
                this.showCpmFloor = 1
            } else {
                this.showCpmFloor = 2
            }
        },
        'detail.mediaId': function(value) {
            let media = _.find(this.filteredMediaList, ['id', value])
            let adResourceType = _.find(this.detail.adResourceTypeList, ['id', this.detail.adResourceType])
            this.detail.name = "联盟-" + media.name + "-" + media.platform + "-" + adResourceType.name
        },
        'detail.adResourceType': function(value) {
            let media = _.find(this.filteredMediaList, ['id', this.detail.mediaId])
            let adResourceType = _.find(this.detail.adResourceTypeList, ['id', value])
            this.detail.name = "联盟-" + media.name + "-" + media.platform + "-" + adResourceType.name
        },
    },
    methods: {
        onInput: function (val) {
            _.assign(this.queryCondition, val);
        },
        onShowPriceChange: function (id) {
            if (id === 2) {
                this.showExpectPrice = 1
                if (this.detail.expectPrice === 1) {
                    this.showCpmFloor = 1
                }
            } else {
                this.showExpectPrice = 2
                this.showCpmFloor = 2
            }
        },
        onExpectPriceChange: function (id) {
            if (id === 1) {
                this.showCpmFloor = 1
            } else {
                this.showCpmFloor = 2
            }
        },
        save: function () {
            this.$element.checkForm(this.$refs.form1);
            this.$element.checkForm(this.$refs.form2);
            this.$element.checkForm(this.$refs.form3);
            this.$element.checkForm(this.$refs.form4);
            window.console.log(this.detail);

            sspApi.editAdzone({data: this.detail}).then(() => {
                //to list page
                this.$router.push({ name: "adzone"}).catch(() => {});
            }).catch(this.$rejectAjaxError());
        },
        onMediaChange: function(id) {
            let media = _.find(this.filteredMediaList, ['id', id])
            if (media.accessType === "SDK") {
                if (this.detail.adResourceType !== 1 && this.detail.adResourceType !== 2) {
                    this.renderingTypeList = [{name: "模版渲染", id: 2}]
                    this.detail.renderingType = 2
                } else {
                    this.renderingTypeList = [{name: "自渲染", id: 1},{name: "模版渲染", id: 2}]
                    this.detail.renderingType = 1
                }
            } else {
                this.renderingTypeList = [{name: "自渲染", id: 1}]
                this.detail.renderingType = 1
            }
            this.detail.name = "联盟-" + media.name
        },
        onAdResourceTypeChange: function(id) {
            let media = _.find(this.filteredMediaList, ['id', this.detail.mediaId])
            if (media.accessType === "SDK") {
                if (id !== 1 && id !== 2) {
                    this.renderingTypeList = [{name: "模版渲染", id: 2}]
                    this.detail.renderingType = 2
                } else {
                    this.renderingTypeList = [{name: "自渲染", id: 1},{name: "模版渲染", id: 2}]
                    this.detail.renderingType = 1
                }
            } else {
                this.renderingTypeList = [{name: "自渲染", id: 1}]
                this.detail.renderingType = 1
            }
        },
        filterMedia: function (value) {
            this.filterMediaValue = value
        },

    }
}
</script>
<style scoped>
    .detail {
       font-size: 10px;
       padding-left: 20px;
    }
    .detail >>> .el-col {
        height: 30px;
        width: 40%;
    }
    .detail >>> .el-input {
        width: 350px;
    }
    .desc {
        height: 110px;
    }
    .desc >>> .el-input__inner {
        height: 200px;
    }
    .detail >>> .el-textarea {
        width: 30%;
    }
    .detail span {
        margin-left: 10px;
        color: red
    }
</style>